export const GetBlank = (typeId) => {
    let result;
    switch (typeId) {
        case 0: result = "/content/doc/BlankVisitorListForEvent.xlsx";
            break;
        case 1: result = "/content/doc/BlankVisitorListForEventExpressTest.xlsx";
            break;
        case 2: result = "/content/doc/BlankVisitorListForPCR.xlsx";
            break;
        case 3: result = "/content/doc/BlankVisitorListForShow.xlsx";
            break;
        case 4: result = "/content/doc/BlankVisitorListForEvent.xlsx";
            break;
        case 5: result = "/content/doc/BlankVisitorListForShow.xlsx";
            break;
            case 6: result = "/content/doc/BlankVisitorListForEvent.xlsx";
            break;
        default: result = typeId
    }
    return result;
}